export default "__VITE_ASSET__DBhE2KT8__"